import React from 'react';
import { Card, Typography, Box } from '@mui/material';

const SummaryCard = ({ title, amount, icon, color }) => {
  return (
    <Card 
      sx={{ 
        color: 'white',
        backgroundColor: color,
        borderRadius: 3,
        boxShadow: '0 4px 12px 0 rgba(0,0,0,0.12)',
        padding: '24px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minHeight: '120px'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', opacity: 0.9 }}>
        {icon}
        <Typography sx={{ ml: 1, fontSize: '0.9rem', fontWeight: 500 }}>
          {title}
        </Typography>
      </Box>
      <Typography variant="h4" sx={{ fontWeight: 'bold', textAlign: 'left', mt: 1 }}>
        {amount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
      </Typography>
    </Card>
  );
};

export default SummaryCard;